<template>
	<Container>
		<div class="content">
			<Row class="page_maintain">
				<Col :lg='12' :md='12' :sm='12'>
				<div class="tu"></div>
				</Col>
				<Col :lg='12' :md='12' :sm='12'>
				<p class="title">{{tt}}</p>
				<div class="desc">
					<section class="section_list">
						<span class="section_left">維護模塊</span>
						<section class="section_right">
							{{title}}
						</section>
					</section>
					<section class="section_list">
						<span class="section_left">開始時間</span>
						<section class="section_right time">
							{{begin||'---'}}
						</section>
					</section>
					<section class="section_list">
						<span class="section_left">結束時間</span>
						<section class="section_right time">
							{{end||'---'}}
						</section>
					</section>
					<p style="color:#BC86C8;padding-left: 40px;">維護時間結束後，請刷新頁麵並重新登錄</p>
				</div>
				</Col>
			</Row>
		</div>

	</Container>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import util from "@/config/util";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
	data() {
		return {
			title: "全部",
			begin: null,
			end: null,
			tt: null
		};
	},
	created() {
		this.$nextTick(function() {
			
		});
	},
	mounted() {
		this.initData();
	},
	watch: {},
	mixins: [],
	components: {
		TopBar
	},
	computed: {
		...mapState({
			sysConfig: state => state.common.sysConfig
		})
	},
	methods: {
		...mapActions([]),
		async initData() {},
		formatNoticeDate(date) {
			if (date && date != "") {
				return util.formatDate.format(date);
			}
			return "";
		},
		back() {
			this.$router.go(-1);
		},
		initData() {
			if (this.$route.query.type) {
				var sys = this.sysConfig.value.maintenance.filter(
					u => u.Code == this.$route.query.type && u.IsAvailable == 1
				);
				if (sys[0]) {
					if (sys[0].ValidFrom) {
						this.begin = sys[0].ValidFrom;
					}
					if (sys[0].ValidTo) {
						this.end = sys[0].ValidTo;
					}
					this.title = sys[0].Name;
					this.tt = sys[0].WX_MaintenanceMessage;
				} else {
					this.$router.replace("/home");
				}
			}
		}
	},
	watch: {
		$route(to, from) {
			if (to.query && to.query.type) {
				this.initData();
			}
		}
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.topbar {
	background-color: #f3f4f5;
	a {
		line-height: 40px;
		margin-left: 10.42vw;
		&:hover {
			color: $theme-color;
		}
	}
}
.content {
	padding-top: 30px;
	margin-bottom: 30px;
}

.page_maintain {
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;

	.tu {
		width: 100%;
		height: 400px;
		background: url("../assets/maintain.jpg") center no-repeat;
		background-size: contain;
	}
	.desc {
		width: 100%;
		text-align: center;
		line-height: 3;
		left: 0;
		@include sc(18px, black);
		font-family: "微軟雅黑";
		font-weight: 700;
		margin-bottom: 100px;
	}
	.title {
		margin-top: 10%;
		text-align: center;
		@include sc(20px, black);
		font-family: "微軟雅黑";
		font-weight: 700;
	}

	.section_list {
		display: flex;

		.section_left {
			@include sc(20px, black);
			flex: 3;
			text-align: right;
		}
		.section_right {
			flex: 5;
			text-align: center;
			@include sc(20px, black);
		}
		.time {
			@include sc(18px, black);
		}
	}
}
</style>